<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6" sm="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Total Alumni</h5>
            <span class="h2 font-weight-bold mb-0">{{ totalAlumni }}</span>
            <template slot="footer"><span class="text-nowrap">{{ filterLabel }}</span></template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6" sm="6">
          <stats-card type="gradient-success" icon="ni ni-check-bold" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Sudah Mengisi</h5>
            <span class="h2 font-weight-bold mb-0">{{ countSudahMengisi }}</span>
            <template slot="footer"><span class="text-success">{{ persenMengisi }}%</span> response rate</template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6" sm="6">
          <stats-card type="gradient-orange" icon="ni ni-bell-55" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Belum Mengisi</h5>
            <span class="h2 font-weight-bold mb-0">{{ countBelumMengisi }}</span>
            <template slot="footer"><span class="text-warning">Perlu di-WA / di-pull</span></template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6" sm="6">
          <stats-card type="gradient-purple" icon="ni ni-tag" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Filter Aktif</h5>
            <span class="h2 font-weight-bold mb-0">{{ activeFilterCount }}</span>
            <template slot="footer"><span class="text-nowrap">{{ filterDescription }}</span></template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0" v-if="selected_tahun == '' ">Data Alumni</h3>
                        <h3 class="mb-0" v-else>Data Alumni {{selected_tahun}}</h3>
                      </b-col>
                      <!-- <b-col class="text-right">
                        <a href="#!" class="btn btn-sm btn-primary"><i class="ni ni-fat-add"></i>Tambah Data</a>
                      </b-col> -->
                    </b-row>
                  </template>

                  <div class="padding">
                    <!-- Inline filter bar with auto-apply -->
                    <div class="filter-bar mb-3 p-3" style="background:#f8f9fa; border-radius:8px;">
                      <b-row class="align-items-end">
                        <b-col md="2" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Basis Tahun</label>
                          <select v-model="filter.jns_tahun" class="form-control form-control-sm" @change="onFilterChange">
                            <option value="kompre">Tahun Lulus / Kompre</option>
                            <option value="wisuda">Tahun Wisuda</option>
                          </select>
                        </b-col>
                        <b-col md="2" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Tahun</label>
                          <select v-model="filter.tahun" class="form-control form-control-sm" @change="onFilterChange">
                            <option :value="''">Semua Tahun</option>
                            <option v-for="t in list_tahun_lulusan" :key="t.tahun" :value="t.tahun">{{ t.tahun }}</option>
                          </select>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Fakultas</label>
                          <select v-model="filter.id_fakultas" class="form-control form-control-sm" @change="onFakultasFilterChange">
                            <option value="">Semua Fakultas</option>
                            <option v-for="f in faculties" :key="f.id_fakultas" :value="f.id_fakultas">
                              {{ f.nm_fakultas }}
                            </option>
                          </select>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Program Studi</label>
                          <select v-model="filter.id_program_studi" class="form-control form-control-sm" @change="onFilterChange">
                            <option value="">{{ filter.id_fakultas ? 'Semua Prodi (di fakultas)' : 'Semua Prodi' }}</option>
                            <option v-for="p in filteredStudyProgramsForFilter" :key="p.id_program_studi" :value="p.id_program_studi">
                              {{ p.jenjang }} - {{ p.nm_program_studi }}
                            </option>
                          </select>
                        </b-col>
                        <b-col md="2" sm="12" class="mb-2 text-right">
                          <b-button-group size="sm" class="w-100">
                            <b-button variant="outline-secondary" @click="resetFilter" title="Reset filter">
                              <i class="fa fa-redo"></i>
                            </b-button>
                            <router-link to="/sync-onedata" class="btn btn-primary" title="Sync OneData">
                              <i class="fas fa-sync"></i>
                            </router-link>
                            <b-button variant="default" @click="downloadFile" title="Download Excel">
                              <i class="fa fa-download"></i>
                            </b-button>
                          </b-button-group>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col md="6">
                          <input v-model="filter.search"
                                 @input="debouncedFilter"
                                 type="text"
                                 class="form-control form-control-sm"
                                 placeholder="Cari NPM / Nama / No. Telp...">
                        </b-col>
                        <b-col md="6" class="text-right">
                          <small class="text-muted">
                            <span v-if="filterLoading"><i class="fa fa-spinner fa-spin"></i> Memuat...</span>
                            <span v-else><strong>{{ totalAlumni }}</strong> alumni ditemukan</span>
                          </small>
                        </b-col>
                      </b-row>
                    </div>
                    <v-client-table :data="tableData" :columns="columns" :options="options">
                      <template slot="status_mengisi" slot-scope="{ row }">
                        <button v-if="row.status_mengisi == 1" class="btn btn-sm btn-success">
                          sudah
                        </button>
                        <button v-if="row.status_mengisi == 0" class="btn btn-sm btn-danger">
                          belum
                        </button>
                      </template>
                    </v-client-table>
                    <!-- Pagination toolbar — single unified control -->
                    <div class="pagination-toolbar d-flex justify-content-between align-items-center flex-wrap px-3 py-3">
                      <div class="d-flex align-items-center text-muted small">
                        <span class="mr-2">Tampilkan</span>
                        <select v-model.number="filter.per_page" @change="applyFilter()" class="form-control form-control-sm per-page-select">
                          <option :value="100">100</option>
                          <option :value="250">250</option>
                          <option :value="500">500</option>
                          <option :value="0">Semua</option>
                        </select>
                        <span class="ml-3">
                          <span v-if="filter.per_page > 0 && totalAlumni > 0">
                            <strong class="text-dark">{{ pageStart }}–{{ pageEnd }}</strong> dari <strong class="text-dark">{{ totalAlumni }}</strong>
                          </span>
                          <span v-else>
                            <strong class="text-dark">{{ totalAlumni }}</strong> data
                          </span>
                        </span>
                      </div>
                      <b-pagination
                        v-if="totalPages > 1"
                        v-model="filter.page"
                        :total-rows="totalAlumni"
                        :per-page="filter.per_page || totalAlumni"
                        @change="onPageChange"
                        size="sm"
                        align="right"
                        class="mb-0"
                        first-number
                        last-number
                        prev-text="‹"
                        next-text="›"
                        first-text="«"
                        last-text="»"
                      ></b-pagination>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";
import { ListSelect  } from 'vue-search-select'

export default {
  name: "Alumni",
  components: {
    BaseHeader,
    Loading,
    ListSelect
  },
  data() {
    return {
      selected_prodi: {
        id_program_studi: '',
        nm_program_studi: ''
      },
      selected_id_tahun: "",
      selected_tahun: "",
      selected_id_fakultas: "",
      list_tahun_lulusan: {},
      study_programs: [],
      faculties: [],
      // Inline filter state (interactive, auto-apply)
      filter: {
        jns_tahun: "kompre",
        tahun: "",
        id_fakultas: "",
        id_program_studi: "",
        search: "",
        page: 1,
        per_page: 100
      },
      filterLoading: false,
      filterTimer: null,
      totalAlumni: 0,
      sudahMengisi: 0,
      belumMengisi: 0,
      totalPages: 1,
      loading: false,
      columns: [
        "username",
        "nama_lengkap",
        "tgl_lahir",
        "nm_fakultas",
        "nm_program_studi",
        "angkatan",
        "tanggal_lulus",
        "tanggal_wisuda",
        "ipk",
        "tlpn_hp",
        "status_mengisi"
      ],
      tableData: [],
      options: {
        // Server-side pagination — set perPage tinggi supaya client tidak paginate
        // ulang row yg sudah ke-load dari server. Disable internal pagination control.
        perPage: 9999,
        perPageValues: [],
        pagination: {
          show: false,
          edge: false,
        },
        headings: {
          username: "NPM",
          nama_lengkap: "Nama Lengkap",
          tgl_lahir: "Tgl Lahir",
          nm_fakultas: "Fakultas",
          nm_program_studi: "Program Studi",
          angkatan: "Angkatan",
          tanggal_lulus: "Tgl Lulus",
          tanggal_wisuda: "Tgl Wisuda",
          ipk: "IPK",
          tlpn_hp: "Telepon",
          status_mengisi: "Status"
        },
        sortable: ["username", "nama_lengkap", "tgl_lahir", "angkatan", "tanggal_lulus", "tanggal_wisuda", "ipk"],
        filterable: false,
        texts: {
          count: " ", // hide bawaan "menampilkan..." karena kita pakai server pagination
          first: "Pertama",
          last: "Terakhir",
          filter: false,
          filterPlaceholder: "",
          limit: false,
          page: "",
          noResults: "Data tidak ditemukan dengan filter yang dipilih",
          loading: "Memuat...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
      }
    };
  },
  computed: {
    filteredStudyPrograms() {
      if (!this.selected_id_fakultas) return this.study_programs;
      var fak = this.selected_id_fakultas;
      return (this.study_programs || []).filter(function (sp) {
        return sp && sp.id_fakultas === fak;
      });
    },
    filteredStudyProgramsForFilter() {
      if (!this.filter.id_fakultas) return this.study_programs || [];
      var fak = this.filter.id_fakultas;
      return (this.study_programs || []).filter(function (sp) {
        return sp && sp.id_fakultas === fak;
      });
    },
    countSudahMengisi() {
      // Pakai stats dari backend (akurat untuk SELURUH filter, bukan cuma row yg ke-load di page).
      return this.sudahMengisi || 0;
    },
    countBelumMengisi() {
      return this.belumMengisi || 0;
    },
    persenMengisi() {
      var t = this.totalAlumni || 0;
      if (t === 0) return 0;
      return ((this.countSudahMengisi / t) * 100).toFixed(1);
    },
    pageStart() {
      if (!this.totalAlumni) return 0;
      return ((this.filter.page - 1) * this.filter.per_page) + 1;
    },
    pageEnd() {
      var end = this.filter.page * this.filter.per_page;
      return end > this.totalAlumni ? this.totalAlumni : end;
    },
    activeFilterCount() {
      var n = 0;
      if (this.filter.tahun) n++;
      if (this.filter.id_fakultas) n++;
      if (this.filter.id_program_studi) n++;
      if (this.filter.search) n++;
      return n;
    },
    filterLabel() {
      var parts = [];
      if (this.filter.tahun) parts.push((this.filter.jns_tahun === 'wisuda' ? 'Wisuda ' : 'Lulus ') + this.filter.tahun);
      else parts.push('Semua tahun');
      return parts.join(' • ');
    },
    filterDescription() {
      var parts = [];
      if (this.filter.id_fakultas) {
        var fak = (this.faculties || []).find(function (f) { return f.id_fakultas === this.filter.id_fakultas; }, this);
        if (fak) parts.push(fak.nm_fakultas);
      }
      if (this.filter.id_program_studi) {
        var prodi = (this.study_programs || []).find(function (p) { return p.id_program_studi === this.filter.id_program_studi; }, this);
        if (prodi) parts.push(prodi.nm_program_studi);
      }
      if (!parts.length) parts.push('Semua fakultas/prodi');
      return parts.join(' › ');
    }
  },
  mounted() {
    var self = this;
    // Restore filter from sessionStorage (preserved across detail navigation)
    var saved = sessionStorage.getItem("alumni_filter");
    if (saved) {
      try {
        var parsed = JSON.parse(saved);
        self.filter = Object.assign(self.filter, parsed);
      } catch (e) { /* ignore */ }
    } else {
      // Default tahun = current year - 1
      self.filter.tahun = String(new Date().getFullYear() - 1);
    }

    DataService.getStudyProgramsJenjang()
      .then(res => {
        self.study_programs = res.data.studyPrograms || [];
      })
      .catch(error => console.error(error));

    DataService.getFaculties()
      .then(res => {
        self.faculties = (res.data && res.data.faculties) || [];
      })
      .catch(error => console.error(error));

    self.getTahun();
    // Initial load with current filter (default or restored)
    self.applyFilter();
  },

  methods: {
    onFakultasChange() {
      // Reset selected prodi when fakultas changes (modal filter)
      this.selected_prodi = { id_program_studi: '', nm_program_studi: '' };
    },
    onFakultasFilterChange() {
      // Inline filter: when fakultas changes, reset prodi
      this.filter.id_program_studi = '';
      this.applyFilter();
    },
    onFilterChange() {
      this.applyFilter();
    },
    debouncedFilter() {
      var self = this;
      if (self.filterTimer) clearTimeout(self.filterTimer);
      self.filterTimer = setTimeout(function () {
        self.applyFilter();
      }, 350);
    },
    applyFilter(resetPage) {
      var self = this;
      // Reset ke page 1 saat filter berubah (kecuali eksplisit page-navigation)
      if (resetPage !== false) self.filter.page = 1;
      self.filterLoading = true;
      // Persist filter so it survives navigation to/from detail page
      try { sessionStorage.setItem("alumni_filter", JSON.stringify(self.filter)); } catch (e) { /* ignore */ }
      self.$store.commit("SHOW_LOADING", "Memuat data alumni...");
      DataService.filterAlumniDynamic(self.filter)
        .then(function (res) {
          self.tableData = res.data.alumni || [];
          self.totalAlumni = res.data.totalAlumni || 0;
          self.sudahMengisi = res.data.sudahMengisi || 0;
          self.belumMengisi = res.data.belumMengisi || 0;
          self.totalPages = (res.data.pagination && res.data.pagination.total_pages) || 1;
          self.filterLoading = false;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function () {
          self.filterLoading = false;
          self.$store.commit("HIDE_LOADING");
        });
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.filter.page = page;
      this.applyFilter(false); // don't reset page
    },
    onPageChange(page) {
      this.filter.page = page;
      this.applyFilter(false);
    },
    resetFilter() {
      this.filter = {
        jns_tahun: 'kompre',
        tahun: '',
        id_fakultas: '',
        id_program_studi: '',
        search: ''
      };
      this.applyFilter();
    },
    reset () {
      this.selected_prodi = {};
      this.selected_id_fakultas = "";
    },
    // selectItem () {
    //   this.selected_prodi = this.study_programs[0]
    //   alert(this.selected_prodi.id_program_studi);
    // },
    downloadFile() {
      var self = this;
      // Use inline filter values if set, else fallback to legacy modal selections
      var jnsTahun = self.filter.jns_tahun === 'wisuda' ? '2' : '1';
      var tahun = self.filter.tahun || self.selected_tahun;
      var idProdi = self.filter.id_program_studi || (self.selected_prodi && self.selected_prodi.id_program_studi) || 'undefined';

      if (!tahun) {
        self.$swal({ icon: "error", title: "Pilih tahun dulu" });
        return;
      }

      self.loading = true;
      self.$store.commit("SHOW_LOADING", "Menyiapkan file Excel data alumni...");
      DataService.downloadFileAlumni(jnsTahun, tahun, idProdi)
        .then(res => {
          self.customDownload(res, "DataAlumni_" + tahun);
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(error => {
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
          self.$swal({ icon: "error", title: "Gagal mengunduh", text: (error.response && error.response.data && error.response.data.message) || "Server error" });
        });
    },
    customDownload(res, filename) {
      var newBlob = new Blob([res.data], {
        type: "application/xlsx"
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".xlsx";
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getTahun() {
      DataService.getTahunLulusanAlumni()
        .then(res => {
          this.list_tahun_lulusan = res.data.tahunLulusan;
        })
        .catch(error => console.error(error));
    },
    // Legacy method shim — redirect ke applyFilter (inline filter)
    getPrograms() {
      this.applyFilter();
    },
    sinkronItem() {
      this.$swal({
        title: "Yakin ingin sinkron data?",
        text: "Sinkron data akan memakan waktu untuk proses",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sinkron Sekarang!",
        cancelButtonText: "Batal"
      }).then(result => {
        this.loading = true;
        if (result.value) {
          DataService.getSinkronAlumni(this.selected_tahun)
            .then(response => {
              this.$swal("Data berhasil diperbaharui");
              this.getPrograms();
            })
            .catch(error => {
              // this.$swal({
              //   icon: "error",
              //   title: "Data gagal diperbaharui"
              // });
              this.$swal("Data berhasil diperbaharui");
              this.getPrograms();
            });
        }
        // this.loading = false;
      });
    },

    // handleOkFilter(bvModalEvt) {
    //     bvModalEvt.preventDefault();
    //     this.handleSubmitFilter();
    // },

    // handleSubmitFilter() {

    // }

  }
};
</script>
<style scoped>
/* Hide v-client-table built-in dropdown limit + row count agar tidak double dgn server pagination */
::v-deep .VueTables__limit-field,
::v-deep .VueTables__limit,
::v-deep .VuePagination,
::v-deep .VueTables__pagination-wrapper {
  display: none !important;
}
::v-deep .VueTables__row-count,
::v-deep .row.VueTables__limit-row,
::v-deep .VueTables__limit-row {
  display: none !important;
}

/* Polish pagination toolbar */
.pagination-toolbar {
  background: #fafbfc;
  border-top: 1px solid #e9ecef;
}
.per-page-select {
  width: auto;
  min-width: 80px;
  display: inline-block;
}
::v-deep .pagination {
  margin: 0;
}
::v-deep .pagination .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: 1px solid #e9ecef;
  color: #525f7f;
  font-weight: 500;
  min-width: 32px;
  text-align: center;
  padding: 0.25rem 0.5rem;
}
::v-deep .pagination .page-item.active .page-link {
  background-color: #5e72e4;
  border-color: #5e72e4;
  color: #fff;
}
::v-deep .pagination .page-item.disabled .page-link {
  color: #cad1d7;
  background: transparent;
}

/* Filter bar polish */
.filter-bar {
  border: 1px solid #e9ecef;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}
</style>
